var map = {
	"./appointments/AppointmentsReport": [
		343,
		0,
		7
	],
	"./appointments/AppointmentsReport.js": [
		343,
		0,
		7
	],
	"./appointments/RemindersReport": [
		344,
		2
	],
	"./appointments/RemindersReport.js": [
		344,
		2
	],
	"./appointments/WaitingReport": [
		345,
		0,
		8
	],
	"./appointments/WaitingReport.js": [
		345,
		0,
		8
	],
	"./communications/BirthdayReport": [
		346,
		0,
		9
	],
	"./communications/BirthdayReport.js": [
		346,
		0,
		9
	],
	"./communications/EmailReport": [
		347,
		0,
		10
	],
	"./communications/EmailReport.js": [
		347,
		0,
		10
	],
	"./communications/PatientFollowupReport": [
		348,
		0,
		11
	],
	"./communications/PatientFollowupReport.js": [
		348,
		0,
		11
	],
	"./communications/WhatsappSMSReport": [
		349,
		0,
		12
	],
	"./communications/WhatsappSMSReport.js": [
		349,
		0,
		12
	],
	"./labwork/LabworkReport": [
		350,
		13
	],
	"./labwork/LabworkReport.js": [
		350,
		13
	],
	"./patients/BillingReport": [
		351,
		14
	],
	"./patients/BillingReport.js": [
		351,
		14
	],
	"./patients/ClinicDashboard": [
		352,
		3
	],
	"./patients/ClinicDashboard.js": [
		352,
		3
	],
	"./patients/ClinicDataAnalysis": [
		353,
		4
	],
	"./patients/ClinicDataAnalysis.js": [
		353,
		4
	],
	"./patients/CollectionReport": [
		354,
		0,
		15
	],
	"./patients/CollectionReport.js": [
		354,
		0,
		15
	],
	"./patients/DoctorReport": [
		355,
		0,
		16
	],
	"./patients/DoctorReport.js": [
		355,
		0,
		16
	],
	"./patients/DoctorWisePatient": [
		356,
		0,
		17
	],
	"./patients/DoctorWisePatient.js": [
		356,
		0,
		17
	],
	"./patients/GeneralReport": [
		357,
		5
	],
	"./patients/GeneralReport.js": [
		357,
		5
	],
	"./patients/OnlinePatientPaymentReport": [
		358,
		0,
		18
	],
	"./patients/OnlinePatientPaymentReport.js": [
		358,
		0,
		18
	],
	"./patients/OutstandingReport": [
		359,
		19
	],
	"./patients/OutstandingReport.js": [
		359,
		19
	],
	"./patients/PatientDocumentReport": [
		360,
		0,
		20
	],
	"./patients/PatientDocumentReport.js": [
		360,
		0,
		20
	],
	"./patients/PatientReport": [
		361,
		0,
		21
	],
	"./patients/PatientReport.js": [
		361,
		0,
		21
	],
	"./patients/ReferenceReport": [
		362,
		0,
		22
	],
	"./patients/ReferenceReport.js": [
		362,
		0,
		22
	],
	"./patients/RevenueReport": [
		363,
		0,
		23
	],
	"./patients/RevenueReport.js": [
		363,
		0,
		23
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 705;
module.exports = webpackAsyncContext;